import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ChangePasswordPayload {
  passwordCurrent: string;
  passwordNew: string;
  passwordConfirm: string;
}

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.css']
})
export class ChangePasswordDialogComponent {
  @Input() visible = false;
  @Input() submitting = false;
  @Input() errorMessage = '';
  @Input() hasError = false;

  @Output() closed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<ChangePasswordPayload>();

  passwordCurrent = '';
  passwordNew = '';
  passwordConfirm = '';
  localError = '';

  readonly passwordPolicy = {
    minLength: 8,
    maxLength: 20,
  };

  passwordNewValid = {
    length: false,
    uppercase: false,
    number: false,
    special: false,
  };

  showPasswordCurrent = false;
  showPasswordNew = false;
  showPasswordConfirm = false;

  togglePasswordVisibility(field: 'current' | 'new' | 'confirm'): void {
    if (field === 'current') {
      this.showPasswordCurrent = !this.showPasswordCurrent;
      return;
    }
    if (field === 'new') {
      this.showPasswordNew = !this.showPasswordNew;
      return;
    }
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  close(): void {
    this.localError = '';
    this.passwordCurrent = '';
    this.passwordNew = '';
    this.passwordConfirm = '';
    this.resetPasswordNewValidation();
    this.showPasswordCurrent = false;
    this.showPasswordNew = false;
    this.showPasswordConfirm = false;
    this.closed.emit();
  }

  onPasswordNewInput(): void {
    const password = this.passwordNew || '';
    const trimmed = password.slice(0, this.passwordPolicy.maxLength);
    if (trimmed !== password) {
      this.passwordNew = trimmed;
    }

    this.passwordNewValid.length =
      trimmed.length >= this.passwordPolicy.minLength && trimmed.length <= this.passwordPolicy.maxLength;
    this.passwordNewValid.uppercase = /[A-Z]/.test(trimmed);
    this.passwordNewValid.number = /\d/.test(trimmed);
    this.passwordNewValid.special = /[^A-Za-z0-9]/.test(trimmed);
  }

  isPasswordNewStrong(): boolean {
    return (
      this.passwordNewValid.length &&
      this.passwordNewValid.uppercase &&
      this.passwordNewValid.number &&
      this.passwordNewValid.special
    );
  }

  private resetPasswordNewValidation(): void {
    this.passwordNewValid = {
      length: false,
      uppercase: false,
      number: false,
      special: false,
    };
  }

  save(): void {
    if (!this.passwordCurrent || !this.passwordNew || !this.passwordConfirm) {
      this.localError = 'Vui lòng nhập đầy đủ mật khẩu.';
      return;
    }

    this.onPasswordNewInput();
    if (!this.isPasswordNewStrong()) {
      this.localError = 'Mật khẩu mới chưa đủ mạnh.';
      return;
    }

    if (this.passwordNew !== this.passwordConfirm) {
      this.localError = 'Mật khẩu mới không khớp.';
      return;
    }

    this.localError = '';
    this.submitted.emit({
      passwordCurrent: this.passwordCurrent,
      passwordNew: this.passwordNew,
      passwordConfirm: this.passwordConfirm,
    });
  }
}
